import { createContext } from "react";
import { AnswerResponse } from "src/api/types";

import { useVisit } from "../VisitProvider";

type ContextType = {
  question_id: string;
  response: AnswerResponse["response"];
};

export const AnswersContext = createContext<ContextType[]>([]);

interface Props {
  children: React.ReactNode;
}

const AnswersProvider = ({ children }: Props) => {
  const answers = useVisit((v) => v.answers ?? []);

  return (
    <AnswersContext.Provider value={answers}>
      {children}
    </AnswersContext.Provider>
  );
};

export default AnswersProvider;
